module.exports = __webpack_public_path__ + "static/media/family_16.fb05f679.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/family/JPEG/family_16.jpg
// module id = 5847
// module chunks = 0